import React, { Dispatch, useEffect, useState } from 'react';
import classes from './organizationInf.module.scss';
import { ReactComponent as Edith } from '../../assets/images/EdithUser.svg';
import { ReactComponent as Clock } from '../../assets/images/userClock.svg';
import { ReactComponent as Pen } from '../../assets/images/userPen.svg';
import { ReactComponent as Eye } from '../../assets/images/userEye.svg';
import {
  useDownload,
  useOrganization,
  useSubdivivsion2,
} from '../../hooks/entityHooks';
import { ReactComponent as EyeOpen } from '../../assets/images/eye.svg';
import { ReactComponent as DownlandComments } from '../../assets/images/downlandComments.svg';

type nameProps = {
  name: string;
  fullName: string;
};

type infoProps = {
  uniqId: string;
  outId: string;
  leaderId: string;
  parentId: string;
  name: string;
};

type actionProps = {
  clickGetFile?: (id: number, type: string) => void;
  setLogs: Dispatch<boolean>;
  organizationInfo: HandleProps;
  isKarmaUser: boolean;
  type: number;
  id: number;
  setConfig: Dispatch<Config>;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  handleGetTree(): void;
};
const createActions = ({
  organizationInfo,
  clickGetFile,
  setLogs,
  handleChangeIsKarmaUser,
  handleGetTree,
  isKarmaUser,
  type,
  id,
  setConfig,
}: actionProps) => {
  return (
    <div className={classes.container__actions}>
      {/* <DownlandComments
        onClick={() => {
          clickGetFile && clickGetFile(id, organizationInfo.type);
        }}
      /> */}
      {/* <Edith onClick={() => setConfig({ state: true, type })} />{' '} */}
      {isKarmaUser ? (
        <EyeOpen
          onClick={() => {
            handleChangeIsKarmaUser(id, type, !isKarmaUser, handleGetTree);
          }}
        />
      ) : (
        <Eye
          onClick={() => {
            handleChangeIsKarmaUser(id, type, !isKarmaUser, handleGetTree);
          }}
        />
      )}{' '}
      {/* <Pen />{' '} */}
      {/* <Clock
        onClick={() => {
          setLogs(true);
        }}
      /> */}
    </div>
  );
};

const createName = ({ fullName, name }: nameProps) => {
  return (
    <div className={classes.container__name}>
      <div className={classes.container__name__title}>{name}</div>
      <div className={classes.container__name__target}>{fullName}</div>
    </div>
  );
};

const createInfo = ({ leaderId, outId, parentId, uniqId, name }: infoProps) => {
  return (
    <>
      {name === 'Подразделение ' ? (
        <div className={classes.container__info}>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              Уникальный идентификатор
            </div>
            <div className={classes.container__info__block__target}>
              {uniqId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID подразделения во внешней системе
            </div>
            <div className={classes.container__info__block__target}>
              {outId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID руководителя организации во внешней системе
            </div>
            <div className={classes.container__info__block__target}>
              {leaderId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID родительского подразделения во внешней системе
            </div>
            <div className={classes.container__info__block__target}>
              {parentId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID организации во внешней системе
            </div>
            <div className={classes.container__info__block__target}>
              {outId}
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.container__info}>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              Уникальный идентификатор
            </div>
            <div className={classes.container__info__block__target}>
              {uniqId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID организации во внешней системе
            </div>
            <div className={classes.container__info__block__target}>
              {outId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID руководителя организации
            </div>
            <div className={classes.container__info__block__target}>
              {leaderId}
            </div>
          </div>
          <div className={classes.container__info__block}>
            <div className={classes.container__info__block__title}>
              ID родительской организации
            </div>
            <div className={classes.container__info__block__target}>
              {parentId}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

type HandleProps = {
  id: number;
  type: string;
  handleGetTree?(): void;
};
type Config = {
  state: boolean;
  type: number;
};
type Props = {
  organizationInfo: HandleProps;
  setConfig: Dispatch<Config>;
  setLogs: React.Dispatch<React.SetStateAction<boolean>>;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  handleUpdateEntity(entityId: number, type: number): Promise<void>;
};
export const OrgInfo = ({
  organizationInfo,
  setLogs,
  handleChangeIsKarmaUser,
  handleUpdateEntity,
  setConfig,
}: Props) => {
  const {
    getEntity: getOrganization,
    entity: organization,
  } = useOrganization();
  const { getEntity: getFile, entity: file } = useDownload();

  const { handleGetTree } = organizationInfo;
  const { getEntity: getSubdivision, entity: subdivision } = useSubdivivsion2();

  const [pastId, setPastId] = useState(-1);

  useEffect(() => {
    if (
      organizationInfo.type === 'Подразделение' &&
      pastId !== organizationInfo.id
    ) {
      getSubdivision(organizationInfo.id);
      setPastId(organizationInfo.id);
    }
    if (
      organizationInfo.type === 'Организация' &&
      pastId !== organizationInfo.id
    ) {
      getOrganization(organizationInfo.id);
      setPastId(organizationInfo.id);
    }
  }, [organizationInfo, handleChangeIsKarmaUser]);

  const clickGetFile = (id: number, type: string) => {
    const searchParams = new URLSearchParams();
    searchParams.append(
      'entity',
      type === 'Подразделение' ? 'subdivision' : 'org',
    );
    getFile(id, searchParams);
  };

  useEffect(() => {
    file &&
      window.open(`https://radar-app.tmk-group.com/${file.name}`, '_blank');
  }, [file]);

  return (
    <>
      {organizationInfo.type === 'Подразделение' ? (
        subdivision ? (
          <div className={classes.container}>
            {createActions({
              clickGetFile,
              isKarmaUser: subdivision.isKarmaUser,
              setConfig,
              setLogs,
              organizationInfo,
              handleChangeIsKarmaUser,
              id: organizationInfo.id,
              type: 2,
              handleGetTree: handleGetTree || (() => {}),
            })}
            {createName({
              fullName: `${subdivision.subDivisionName}`,
              name: `${organizationInfo.type} `,
            })}
            {createInfo({
              parentId: subdivision.subDivisionParentGUID,
              leaderId: subdivision.subDivisionManagerGUID,
              outId: subdivision.subDivisionGUID,
              uniqId: subdivision.id.toString(),
              name: `${organizationInfo.type} `,
            })}
          </div>
        ) : null
      ) : organization ? (
        <div className={classes.container}>
          {createActions({
            clickGetFile,
            type: 1,
            id: organizationInfo.id,
            isKarmaUser: organization.isKarmaUser,
            setLogs,
            organizationInfo,
            handleChangeIsKarmaUser,
            setConfig,
            handleGetTree: handleGetTree || (() => {}),
          })}
          {createName({
            fullName: `${organization.orgName}`,
            name: `${organization.orgShortName} `,
          })}
          {createInfo({
            parentId: '',
            leaderId: organization.orgManagerGUID,
            outId: organization.orgGUID,
            uniqId: organization.id.toString(),
            name: `${organizationInfo.type} `,
          })}
        </div>
      ) : null}
    </>
  );
};
